<div class="iframe-container">
    <iframe #demoFrame [src]="demoUrl | safeResourceUrl" allowfullscreen title="Demo Embed"> </iframe>
</div>
